<script lang="ts">
  import { goto } from '$app/navigation';

  import { createEventDispatcher } from 'svelte';

  import type { Photo } from '@do/models';

  import { cn } from '@shared/utils';

  import BlurWrapper from './blur-wrapper.svelte';
  import GradientCard from './gradient-card.svelte';
  import Image from './image.svelte';

  export let title: string;
  export let slug: string;
  export let cover: Photo | null;
  export let imgElement: HTMLImageElement | undefined = undefined;
  export let classes = '';
  export let contentClasses = '';
  export let hasHover = true;

  const dispatcher = createEventDispatcher<{ navigate: void }>();

  const blurredCardClasses = {
    first: `z-[2] translate-y-[5%] scale-[95%] ${hasHover ? 'group-hover:translate-y-[5.5%]' : ''}`,
    second: `z-[1] translate-y-[10%] scale-[90%] ${hasHover ? 'group-hover:translate-y-[10.5%]' : ''}`,
  };

  const cardTransitionClass = 'transition-transform duration-700';
</script>

<a
  href="/selection-{slug}/"
  class="{cn('group flex flex-col gap-8 rounded-xl', classes)}"
  on:click="{() => {
    goto(`/selection-${slug}/`);
    dispatcher('navigate');
  }}"
>
  <div class="group relative z-10">
    {#if cover}
      <div
        class="{cn('relative z-[3] h-full w-full overflow-hidden rounded-xl', cardTransitionClass, {
          'group-hover:-translate-y-[4px]': hasHover,
        })}"
      >
        <Image image="{cover}" {title} on:load bind:imgElement />
      </div>

      <BlurWrapper classes="{blurredCardClasses.first} {cardTransitionClass}" blur="md">
        <Image image="{cover}" {title} />
      </BlurWrapper>

      <BlurWrapper classes="{blurredCardClasses.second} {cardTransitionClass}" blur="sm">
        <Image image="{cover}" {title} />
      </BlurWrapper>
    {:else}
      <GradientCard />

      <BlurWrapper classes="{blurredCardClasses.first}" blur="md">
        <GradientCard />
      </BlurWrapper>

      <BlurWrapper classes="{blurredCardClasses.second}" blur="sm">
        <GradientCard />
      </BlurWrapper>
    {/if}
  </div>

  <div class="{contentClasses}">
    <slot name="title" />

    <slot name="total-count" />
  </div>
</a>
